import cmTimeouts from '../../consts/config/cmTimeouts';
import * as logMessageTypes from '../../consts/log/logMessageTypes';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../state/selectors/consumer';
import {selectIsDeviceReady} from '../../state/selectors/iotDevice';
import {makeSelectIsYapDeviceConnected, makeSelectIsYapHolderConnected} from '../../state/selectors/yapEncrypted';
import {getState} from '../../state/store';
import helpers from '../../utils/helpers';
import analyticsService from '../analyticsService';
import log from '../logger/log';
import DeviceCmClient from './DeviceCmClient';
import HolderCmClient from './HolderCmClient';

const getCmClient = (isHolder) => (id, options) => {
    try {
        const Client = isHolder ? HolderCmClient : DeviceCmClient;

        return new Client(id, options);
    } catch (e) {
        return null;
    }
};

const waitUntilConnected = async (params) => {
    const {isHolder, isCheckDeviceReady = false} = params || {};
    let {timer = cmTimeouts.CM_CONNECT_TIMEOUT * 10} = params || {};

    const state = getState();
    const isYapDeviceConnected = isHolder
        ? makeSelectIsYapHolderConnected()(state)
        : makeSelectIsYapDeviceConnected()(state);
    const isDeviceReady = selectIsDeviceReady(state);

    if (isYapDeviceConnected && (isDeviceReady || !isCheckDeviceReady)) return true;

    const cmClient = getCmClient(isHolder)();

    if (!cmClient) return false;

    if (--timer < 0) {
        const type = getDeviceType();

        analyticsService.pushConnectIotPlatformErrorEvent(type);
        if (isCheckDeviceReady) {
            log.error(
                `CM Client. CONNECTED status does not arrive from yap websocket or device is not ready. isHolder: ${isHolder}`,
                logMessageTypes.IOT
            );
        } else {
            log.error(
                `CM Client. CONNECTED status does not arrive from yap websocket. isHolder: ${isHolder}`,
                logMessageTypes.IOT
            );
        }
        return false;
    }

    await helpers.timeout(100);
    return await waitUntilConnected({isHolder, timer, isCheckDeviceReady});
};

const getDeviceType = () => {
    const iotProduct = makeSelectIotDeviceMergedWithConsumerProduct()(getState());

    return iotProduct?.device?.type;
};

export default {
    getCmClient,
    getDeviceType,
    waitUntilConnected,
};
